import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    textAlign: "center",
    height: "100%",
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  buttonBox: {
    marginTop: theme.spacing(1),
  },
  title: {
    minHeight: 83,
  },
  tileContent: {
    minHeight: 60,
  },
  but: {
    borderWidth: "5px",
    borderColor: "maroon",
    color: "maroon",
    padding: "5px",
    height: "100%",
  },
  gridItem: {
    margin: theme.spacing(1),
  },
  appBox: {
    minHeight: "100vh",
    marginBottom: "20px",
    padding: "32px",
  },
  appGrid: {
    height: "fit-content",
    marginBottom: "20px",
    borderLeft: "8px solid #8C1D40",
  },
  accordionTitle: {
    display: "flex",
    alignContent: "center",
    fontWeight: "bold !important",
  },
  accordionSummary: {
    textAlign: "left",
    "& p": {
      font: "normal normal bold 20px/26px Arial !important",
    },
    letterSpacing: "-0.5px",
    color: "#191919",
    paddingLeft: "32px !important",
  },
  accordionDetails: {
    textAlign: "left",
    font: "normal normal bold 20px/26px Arial",
    letterSpacing: "-0.5px",
    color: "#191919",
    padding: "32px !important",
    background: "#FAFAFA 0% 0% no-repeat padding-box",
  },
  tableHeader: {
    display: "flex",
    alignContent: "center",
    justifyContent: "start",
    marginBottom: "40px",
  },
  tableHeadRow: {
    background: "#D0D0D0",
  },
  tableHeadCell: {
    width: "auto",
    font: "normal normal bold 16px/21px Arial !important",
  },
  tableBodyRow: {
    letterSpacing: "-0.24px",
    "&:hover": {
      "& td, th": {
        fontWeight: "bold",
      },
      background: "#E8E8E8 0% 0% no-repeat padding-box",
    },
  },
  optionsButton: {
    margin: "10px 20px 20px 0px",
    background: "#BFBFBF 0% 0% no-repeat padding-box",
    "&:hover": {
      background: "#BFBFBF 0% 0% no-repeat padding-box",
    },
    borderRadius: "25px",
    color: "#191919",
    fontWeight: "bold",
    textTransform: "none",
    width: "auto",
    height: "32px",
    padding: "8px 16px",
    font: "normal normal bold 14px/24px Arial",
  },
  chooseTestButton: {
    margin: "2px 120px 0px 0px",
    background: "#BFBFBF 0% 0% no-repeat padding-box",
    "&:hover": {
      background: "#BFBFBF 0% 0% no-repeat padding-box",
    },
    fontWeight: "bold",
    borderRadius: "25px",
    color: "#191919",
    textTransform: "none",
    width: "auto",
    height: "32px",
    padding: "8px 16px",
    font: "normal normal bold 14px/24px Arial",
  },
  inpErrorMsg: {
    font: "normal normal normal 14px/16px Arial",
    color: "maroon",
    margin: "0px 0px 10px 10px",
  },
  resultsDiv: {
    padding: "0px 10px 20px 0px"
  },
  resultsButton: {
    font: "normal normal bold 16px/24px Arial",
    background: "#8C1D40 0% 0% no-repeat padding-box",
    borderRadius: "25px",
    color: "#FAFAFA",
    textTransform: "none",
    "&:hover": {
      background: "#8C1D40 0% 0% no-repeat padding-box",
    },
    width: "auto",
    height: "49px",
    padding: "16px 32px",
  },
  buyButton: {
    background: "#8C1D40 0% 0% no-repeat padding-box",
    borderRadius: "25px",
    color: "#FAFAFA",
    textTransform: "none",
    width: "auto",
    height: "22px",
    padding: "4px 12px",
    marginRight: "10px",
    "&:hover": {
      background: "#8C1D40 0% 0% no-repeat padding-box",
    },
    font: "normal normal bold 12px/18px Arial",
  },
  appBoxText: {
    color: "#191919",
    textAlign: "left",
    font: "normal normal normal 16px/24px Arial",
    letterSpacing: "0px",
    padding: "0px 16px 16px 16px",
  },
}));

export default useStyles;
